import React, { useEffect } from 'react';
import { navigate } from '@reach/router';

const RedirectToHome = ({ basepath }) => {
  useEffect(() => {
    navigate(basepath || '/', { replace: true });
  }, [basepath]);

  return null;
};

export default RedirectToHome;
